import { ChartDataArray } from '../data/ChartDataArray';
import { ChartDataComparisonType } from '../data/ChartDataComparisonType';
import { ChartDataType } from '../data/ChartDataType';
import { ColumnBarChartAttrHandler } from './ColumnBarChartAttrHandler';
import { DataRenderer } from './DataRenderer';

export class ColumnBarRenderer extends DataRenderer {
  static readonly PADDING = 8;
  static readonly COMPARISON_EXTRA = 6;
  static readonly SECONDARY_EXTRA = 4;

  protected className?: string;

  constructor(
    private gElement: d3.Selection<SVGGElement, unknown, null, undefined>,
    data: ChartDataArray,
    protected hasComparison: boolean
  ) {
    super();

    if (data.comparisonType === ChartDataComparisonType.plan) {
      this.className = 'bar bar-plan';
    } else if (data.type === ChartDataType.primary) {
      this.className = !data.isComparison ? 'bar' : 'bar bar-comparison';
    } else if (data.type === ChartDataType.secondary) {
      this.className = !data.isComparison ? 'bar bar-secondary' : 'bar bar-secondary bar-comparison';
    }
  }

  protected renderInternal(
    array: ChartDataArray,
    handlers: ColumnBarChartAttrHandler,
    limit?: number,
    inverted?: boolean
  ) {
    const data = array.getData(limit, inverted);

    this.gElement
      .append('g')
      .selectAll('.bar-main')
      .data(data)
      .enter()
      .append('rect')
      .attr('class', handlers.class || null)
      .attr('x', handlers.x!)
      .attr('y', handlers.y!)
      .attr('width', handlers.width!)
      .attr('height', handlers.height!)
      .style('fill', d => d.color ?? null);
  }

  switchHighlight(_index: number, _highlight: boolean) {
    throw new Error('Method not implemented.');
  }
}
